import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const TiposDocumentos = () => {
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [filteredTiposDocumentos, setFilteredTiposDocumentos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    tipo_documento: '',
    acao: '',
    ativo: true,
    tramitar: false,
    avulso: false
  });

  useEffect(() => {
    const carregarTiposDocumentos = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/tipos-documentos`
        );

        if (!response.ok) {
          throw new Error('Erro ao buscar tipos de documento');
        }

        const data = await response.json();
        setTiposDocumentos(data);
        setFilteredTiposDocumentos(data);
      } catch (error) {
        console.error('Erro ao carregar tipos de documento:', error);
        alert(
          'Erro ao carregar tipos de documento. Verifique a conexão com o servidor.'
        );
      }
    };

    carregarTiposDocumentos();
  }, []);

  useEffect(() => {
    const termo = searchTerm.toLowerCase();
    const filtrados = tiposDocumentos.filter((tipo) =>
      `${tipo.tipo_documento || ''} ${tipo.acao || ''}`
        .toLowerCase()
        .includes(termo)
    );
    setFilteredTiposDocumentos(filtrados);
  }, [searchTerm, tiposDocumentos]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      tipo_documento: formData.tipo_documento,
      acao: formData.acao,
      ativo: formData.ativo,
      tramitar: formData.tramitar,
      avulso: formData.avulso
    };

    try {
      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/tipos-documentos/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar tipo de documento');
        }
      } else {
        const response = await fetch(
          `${API_BASE_URL}/tipos-documentos`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar tipo de documento');
        }
      }

      const listaAtualizada = await (
        await fetch(`${API_BASE_URL}/tipos-documentos`)
      ).json();

      setTiposDocumentos(listaAtualizada);
      setFilteredTiposDocumentos(listaAtualizada);
      resetForm();
    } catch (error) {
      console.error('Erro ao salvar tipo de documento:', error);
      alert(
        'Erro ao salvar tipo de documento. Verifique os dados e tente novamente.'
      );
    }
  };

  const handleEdit = (tipo) => {
    setFormData({
      tipo_documento: tipo.tipo_documento,
      acao: tipo.acao || '',
      ativo: tipo.ativo,
      tramitar: tipo.tramitar,
      avulso: tipo.avulso
    });
    setEditingId(tipo.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir este tipo de documento?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/tipos-documentos/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir tipo de documento');
      }

      const listaAtualizada = await (
        await fetch(`${API_BASE_URL}/tipos-documentos`)
      ).json();

      setTiposDocumentos(listaAtualizada);
      setFilteredTiposDocumentos(listaAtualizada);
    } catch (error) {
      console.error('Erro ao excluir tipo de documento:', error);
      alert(
        'Erro ao excluir tipo de documento. Tente novamente mais tarde.'
      );
    }
  };

  const resetForm = () => {
    setFormData({
      tipo_documento: '',
      acao: '',
      ativo: true,
      tramitar: false,
      avulso: false
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (tipo) => {
    const novoStatus = !tipo.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/tipos-documentos/${tipo.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            tipo_documento: tipo.tipo_documento,
            acao: tipo.acao,
            ativo: novoStatus,
            tramitar: tipo.tramitar,
            avulso: tipo.avulso
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do tipo de documento');
      }

      setTiposDocumentos((prev) =>
        prev.map((item) =>
          item.id === tipo.id ? { ...item, ativo: novoStatus } : item
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do tipo de documento:', error);
      alert(
        'Erro ao atualizar status do tipo de documento. Tente novamente.'
      );
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Tipos de Documentos</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Tipo de Documento' : 'Cadastrar Tipo de Documento'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="tipo_documento">Tipo de Documento *</label>
              <input
                type="text"
                id="tipo_documento"
                value={formData.tipo_documento}
                onChange={(e) => setFormData({...formData, tipo_documento: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o tipo de documento"
              />
            </div>

            <div className="form-group">
              <label htmlFor="acao">Ação</label>
              <input
                type="text"
                id="acao"
                value={formData.acao}
                onChange={(e) =>
                  setFormData({ ...formData, acao: e.target.value })
                }
                maxLength={100}
                placeholder="Ex: Exigir / Anexar / Validar"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="tramitar"
                label="Tramitar:"
                checked={formData.tramitar}
                checkedLabel="Sim"
                uncheckedLabel="Não"
                onChange={(e) =>
                  setFormData({ ...formData, tramitar: e.target.checked })
                }
              />
            </div>

            <div className="form-group">
              <Toggle
                id="avulso"
                label="Avulso:"
                checked={formData.avulso}
                checkedLabel="Sim"
                uncheckedLabel="Não"
                onChange={(e) =>
                  setFormData({ ...formData, avulso: e.target.checked })
                }
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                checkedLabel="Ativo"
                uncheckedLabel="Inativo"
                onChange={(e) =>
                  setFormData({ ...formData, ativo: e.target.checked })
                }
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar tipos de documentos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredTiposDocumentos.length} registro(s) encontrado(s)</span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Tipo
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Tipo de Documento</th>
                  <th className="col-nome">Ação</th>
                  <th className="col-status">Tramitar</th>
                  <th className="col-status">Avulso</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredTiposDocumentos.map(tipo => (
                  <tr key={tipo.id}>
                    <td className="col-id">{tipo.id}</td>
                    <td className="col-nome">{tipo.tipo_documento}</td>
                    <td className="col-nome">{tipo.acao || '-'}</td>
                    <td className="col-status">{tipo.tramitar ? 'Sim' : 'Não'}</td>
                    <td className="col-status">{tipo.avulso ? 'Sim' : 'Não'}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={tipo.ativo}
                          onChange={() => handleToggleStatus(tipo)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(tipo)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(tipo.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredTiposDocumentos.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum tipo de documento encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo tipo de documento.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TiposDocumentos;
